import { render, staticRenderFns } from "./InventoryLabResultIndex.vue?vue&type=template&id=b128a25a"
import script from "./InventoryLabResultIndex.vue?vue&type=script&lang=js"
export * from "./InventoryLabResultIndex.vue?vue&type=script&lang=js"
import style0 from "./InventoryLabResultIndex.vue?vue&type=style&index=0&id=b128a25a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b128a25a')) {
      api.createRecord('b128a25a', component.options)
    } else {
      api.reload('b128a25a', component.options)
    }
    module.hot.accept("./InventoryLabResultIndex.vue?vue&type=template&id=b128a25a", function () {
      api.rerender('b128a25a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventoryLabResult/InventoryLabResultIndex.vue"
export default component.exports